export const MINDMAP_DIAGRAM_TESTCASES = [
  {
    name: "Basic Mindmap",
    type: "mindmap",
    definition: `mindmap
  root((Main Topic))
    Topic 1
      Subtopic 1.1
      Subtopic 1.2
    Topic 2
      Subtopic 2.1
`,
  },
] as const;
